import { InjectionToken } from '@angular/core';
import { TypedDocumentNode } from 'apollo-angular';
import { NoteOwner } from './note-graphql.service';

export const NOTE_GRAPHQL_CONFIG = new InjectionToken<NoteGraphqlConfig>('NOTE_GRAPHQL_CONFIG');

export type NoteGraphqlConfig = {
  owner: NoteOwner;
  refetchQueries?: TypedDocumentNode<any, any>[];
};
